import { render, staticRenderFns } from "./BuyerUsers.vue?vue&type=template&id=2be1367f&scoped=true&"
import script from "./BuyerUsers.vue?vue&type=script&lang=js&"
export * from "./BuyerUsers.vue?vue&type=script&lang=js&"
import style0 from "./BuyerUsers.vue?vue&type=style&index=0&id=2be1367f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1367f",
  null
  
)

export default component.exports